import React, { useState, useEffect, useRef } from "react";
import { Button, Modal } from 'react-bootstrap';
import RaceEvents from "./RaceEvents";
import '../css/Race.css';

function RaceFinancesModal(props) {

    const mounted = useRef(false);
    const [show, setShow] = useState(false);
    const handleClose = () => props.handleClose();

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (mounted.current) {
            setShow(props.show);
        }
    }, [props.refresh]);

    return <>
        <Modal key={'financesModal' + show}
            size="xl"
            show={show}
            onHide={handleClose} >
            <Modal.Header>
                <Modal.Title>Prize Money and Points</Modal.Title>
                <Button className="py-0 m-0" variant="danger" onClick={handleClose}>{'X'}</Button>
            </Modal.Header>
            <Modal.Body closeButton style={{ backgroundColor: 'rgba(222,233,244,1)', padding: 0, margin: 0 }}>
                <RaceEvents raceEdition={props.raceEdition} teamName={props.teamName} refresh={show} />
            </Modal.Body>
        </Modal>
    </>
}

export default RaceFinancesModal;